import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import {Lato} from 'Shared/frontend/fonts/Lato';


export class SneakyPossumSettings extends BaseSettings
{
	palette()
	{
		return {
			background: 'black',
			text: 'white', //orange '#b08bf6', //purple 
			feature: '#db7746', //orange

			/* Eg the mobile nav colour */
			dimBackground: '#1b2126',

			food: '', 
			drinks: '',
			
			// CJ added: needed to change scrollBar colors for light theme
			scrollBar: {
			//	scrollbarColor: '#fdfae7 #f6e9d2 !important',
			}
		};
	}

	fontIncludes()
	{
		return [ Lato ];
	}

	fonts() {
		return {
			text: '"Lato", sans-serif',
			teaser: '"Lato", sans-serif',
			heading: '"Lato", serif',
			tagline: '"Lato", sans-serif',
			buttons: '"Lato", sans-serif',
			desktopNav: '"Lato", sans-serif',
			menuItem: '"Lato", sans-serif',
			mobileNav: '"Lato", sans-serif',
			subNav: '"Lato", sans-serif',
		};
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().feature,
				},
				dateBar: {
					backgroundColor: this.palette().background,
				},
			},
		});
	}
	
	page()
	{
		return merge(super.page(), {
			heading: {
				color: this.palette().feature,
			},
			section: {
				title: {
					color: this.palette().feature,
					fontWeight: '400',
					fontSize:'clamp(1.8rem, 4vw, 3rem)!important',
				//	letterSpacing: 3, 
					textTransform: 'initial',
				},

			
				teaser:{
					color: this.palette().feature,
					fontFamily: this.fonts().teaser,
					fontWeight: '500',
					fontSize:'clamp(1.2rem, 5vw, 3rem)!important',	
				},
				tagline:{
					color: this.palette().feature,
					fontFamily: this.fonts().tagline,
					fontWeight: '300 !important',
					fontSize:'clamp(1.2rem, 5vw, 2rem)!important',	
				},
			},

			widgets: {
				subNav: {
					button: {
						backgroundColor: this.palette().text
					}
				},
			},

			button: {
				backgroundColor: this.palette().feature,
				borderRadius: '0.4em',
			},
		});
	}


	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		const settings = merge(base, <DeepPartial<BaseThemeType>>{
			nav: {
				desktop: {
					button: {
						color: palette.feature,
					},
					active: {
						color: palette.text
					},
					hover: {
						color: palette.text
					}
				},
			},

			event: {
				artist: {
					heading: {
						color: palette.feature,
						fontFamily: 'sans-serif'
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature,
						},
					}, 
					genresAndLocation: {
						color: palette.text
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						color: palette.feature,
						border: 'solid 3px',
						borderColor: palette.feature,
					},
					buttonType: type => ({ backgroundColor: palette.background })
				},
				section: {
					heading: {
						fontFamily: this.fonts().menuItem,
						fontSize:'clamp(2rem, 4vw, 3.5rem)!important',
						color: palette.feature,
					},
				},
				item: {
					type: 'imageless',
					title: { 
						fontFamily: this.fonts().menuItem,
						fontSize: '1.3em',
					},
				},
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}
}

